import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ReactComponent as ContendZONE } from "../../assets/images/contendZONEone.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import homeIcon from "../../assets/images/side-menu/home.png";
import guidelinesIcon from "../../assets/images/side-menu/guidelines.png";
import highlightsIcon from "../../assets/images/side-menu/highlights.png";
import pricingIcon from "../../assets/images/side-menu/pricing.png";
import blogIcon from "../../assets/images/side-menu/blog.png";
import contactIcon from "../../assets/images/side-menu/contact-us.png";
import { getHeaderData } from "../../store/actions/publicHeader";

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      showCollapsedMenu: false,
      isHome: window.location.pathname === "/",
      loginClass: "login-btn",
      showHeaderBackground: false,
    };
  }

  listenScrollEvent = (e) => {
    if (window.scrollY > 200) {
      this.setState({ loginClass: "login-btn-2", showHeaderBackground: true });
    } else {
      this.setState({ loginClass: "login-btn", showHeaderBackground: false });
    }
  };

  toggleMenu = () => {
    this.setState({
      showCollapsedMenu: !this.state.showCollapsedMenu,
    });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.listenScrollEvent);
  }

  render() {
    const { isHome, showHeaderBackground } = this.state;
    // const {
    //   payload: { home, highlights, blog, contactUs, guidelines, pricing },
    // } = this.props;
    const show = this.state.showCollapsedMenu ? "show" : "";
    return (
      <section>
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 bannerstyle bg-ban-one">
          <div className="conclass">
            <div className="row m-0 ">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <nav
                  id="navigation"
                  className={`navbar disw stretch diswmob navbar-expand-lg navbar-light text-danger fixed-top font-weight-bold ${
                    !isHome || showHeaderBackground ? "navBarOther" : ""
                  }`}
                >
                  <Link to="/">
                    <ContendZONE id="mainlogo1" />
                  </Link>
                  <div className={"menu-button-container"}>
                    <Link
                      to="/login"
                      type="button"
                      className="login-btn"
                      id="moboshow"
                    >
                      <Link className="fs-18 bold" to="/login">
                        LOG IN
                      </Link>
                    </Link>
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-toggle="collapse"
                      data-target="#navbarCollapse"
                      aria-controls="navbarCollapse"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                      onClick={this.toggleMenu}
                    >
                      <FontAwesomeIcon icon={faBars} id="ham-burger-menu" />
                    </button>
                  </div>
                  <div
                    className={"collapse navbar-collapse " + show}
                    id="navbarCollapse"
                  >
                    <ul className="navbar-nav ml-auto" id="webHeaderCollapse">
                      <li className="mobile-menu-header">
                        <button type="button" onClick={this.toggleMenu}>
                          <FontAwesomeIcon
                            icon={faAngleRight}
                            className="close-header"
                          />
                        </button>
                        <ContendZONE className="menu-logo" />
                      </li>
                      <li className="nav-item ">
                        <Link
                          className={`nav-link mr70 fs-20 semibold ${
                            window.location.pathname === "/"
                              ? "active-link"
                              : ""
                          }`}
                          to="/"
                        >
                          <img
                            alt=""
                            src={homeIcon}
                            className="side-menu-icon"
                          />
                          Home
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link
                          className={`nav-link mr70 fs-20 semibold ${
                            window.location.pathname === "/guidelines"
                              ? "active-link"
                              : ""
                          }`}
                          to="/guidelines"
                        >
                          <img
                            alt=""
                            src={guidelinesIcon}
                            className="side-menu-icon"
                          />
                          Guidelines
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link
                          className={`nav-link mr70 fs-20 semibold ${
                            window.location.pathname === "/highlights"
                              ? "active-link"
                              : ""
                          }`}
                          to="/highlights"
                        >
                          <img
                            alt=""
                            src={highlightsIcon}
                            className="side-menu-icon"
                          />
                          Highlights
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link
                          className={`nav-link mr70 fs-20 semibold ${
                            window.location.pathname === "/pricing"
                              ? "active-link"
                              : ""
                          }`}
                          to="/pricing"
                        >
                          <img
                            alt=""
                            src={pricingIcon}
                            className="side-menu-icon"
                          />
                          Pricing
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className={`nav-link mr70 fs-20 semibold ${
                            window.location.pathname === "/contactus"
                              ? "active-link"
                              : ""
                          }`}
                          to="/contactus"
                        >
                          <img
                            alt=""
                            src={contactIcon}
                            className="side-menu-icon"
                          />
                          Contact-Us
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/signup"
                          // id="login"
                          type="button"
                          className="sign-btn mr-2 text-center mt-12"
                          id="deskshow1"
                        >
                          <Link
                            className="txtblue bold fs-18 "
                            id="reqdemo"
                            to="/signup"
                          >
                            Sign Up
                          </Link>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/login"
                          // id="login"
                          type="button"
                          className={`${this.state.loginClass} text-center mt-12`}
                          id="deskshow2"
                        >
                          <Link className="fs-18 bold" to="/login">
                            {" "}
                            LOG IN
                          </Link>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

// const mapStateToProps = (state) => ({
//   payload: state.publicHeader.payload,
// });

// const mapDispatchToProps = (dispatch) => ({
//   getHeader: () => {
//     dispatch(getHeaderData());
//   },
// });

// export default connect(mapStateToProps, mapDispatchToProps)(Header);
export default Header;
